<template>
	<div v-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp)">
		<!-- 関連注文商品ボタンを追加 -->
		<div :class="'sort-item kanrenOrder kanrenOrderProduct_' + index"
			v-for="(item, index) in ptInitData.listKanrenOrderProductInfo" :key="index">
			<div :class="'kanrenOrderProduct kanrenOrderProduct_' + index"
				v-if="!common.isNullItem(item.BUTTON_NM) && !common.isNullItem(item.KANREN_ORDER_ITEM_CD) && (item.BUTTON_PAGE == 1 || item.BUTTON_PAGE == 2)">
				<button
					:class="(ptInitData.siteKbn == '4' && !ptInitData.loginKbn) == false ? ' kanrenOrderBtn kanrenOrderBtn_' + index : 'disabled' + ' kanrenOrderBtn kanrenOrderBtn_' + index"
					@click="pt125doKanrenOrder(item.KANREN_ORDER_ITEM_CD, item.BUTTON_KBN)"
					:disabled="(ptInitData.siteKbn == '4' && !ptInitData.loginKbn) == false ? false : true">
					<span v-html="item.BUTTON_NM"></span>
				</button>
			</div>
		</div>
	</div>

</template>
<script>
import common from "assets/js/common";
	export default {
		name: 'kanrenOrder',
		props: {
			ptInitData: {
				type: Object,
				default: null
			},
			isLp: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				common
			}
		},
		methods: {
			pt125doKanrenOrder(KANREN_ORDER_ITEM_CD,BUTTON_KBN) {
				this.$emit('pt125doKanrenOrder', KANREN_ORDER_ITEM_CD,BUTTON_KBN);
			}
		}
	}
</script>